import { render, staticRenderFns } from "./DoubleInputSearch.vue?vue&type=template&id=05a08348&scoped=true&"
import script from "./DoubleInputSearch.vue?vue&type=script&lang=js&"
export * from "./DoubleInputSearch.vue?vue&type=script&lang=js&"
import style0 from "./DoubleInputSearch.vue?vue&type=style&index=0&id=05a08348&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a08348",
  null
  
)

export default component.exports